import { Mark, mergeAttributes, markInputRule, markPasteRule } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

export const ClearSpaceBlock = Mark.create({
    name: 'clearSpaceBlock',
    parseHTML() {
        return [
            {
                tag: 'span[data-type="clear-space-block"]',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [
            'span',
            mergeAttributes(HTMLAttributes, {
                'data-type': 'clear-space-block',
                class: 'clear-space-block',
            }),
            0,
        ];
    },
    addInputRules() {
        return [
            markInputRule({
                find: /@([^@]+)@$/,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: /@([^@]+)@/g,
                type: this.type,
            }),
        ];
    },
    addProseMirrorPlugins() {
        const pluginKey = new PluginKey('clearSpaceBlockAtSign');
        return [
            new Plugin({
                key: pluginKey,
                props: {
                    decorations(state) {
                        const { doc } = state;
                        const decorations = [];
                        let currentRange = null;

                        doc.descendants((node, pos) => {
                            if (!node.isInline) {
                                if (currentRange) {
                                    decorations.push(...createClearSpaceDecorations(currentRange));
                                    currentRange = null;
                                }
                                return true;
                            }

                            const mark = node.marks?.find((m) => m.type.name === 'clearSpaceBlock');

                            if (mark) {
                                if (currentRange) {
                                    currentRange.to = pos + node.nodeSize;
                                } else {
                                    currentRange = {
                                        from: pos,
                                        to: pos + node.nodeSize,
                                    };
                                }
                            } else {
                                if (currentRange) {
                                    decorations.push(...createClearSpaceDecorations(currentRange));
                                    currentRange = null;
                                }
                            }
                            return false;
                        });

                        if (currentRange) {
                            decorations.push(...createClearSpaceDecorations(currentRange));
                        }

                        return DecorationSet.create(doc, decorations);
                    },
                },
            }),
        ];
    },
});

function createClearSpaceDecorations(range) {
    const startWidget = Decoration.widget(
        range.from,
        () => {
            const span = document.createElement('span');
            span.className = 'clear-space-widget clear-space-start';
            span.setAttribute('contenteditable', 'false');
            span.textContent = '@';
            return span;
        },
        { side: -5, stopEvent: () => false, ignoreSelection: true }
    );

    const endWidget = Decoration.widget(
        range.to,
        () => {
            const span = document.createElement('span');
            span.className = 'clear-space-widget clear-space-end';
            span.setAttribute('contenteditable', 'false');
            span.textContent = '@';
            return span;
        },
        { side: 5, stopEvent: () => false, ignoreSelection: true }
    );

    return [startWidget, endWidget];
}
